import { TranslatePipe } from '@ngx-translate/core';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NgClass, RouterLink, RouterLinkActive],
})
export class NavigationComponent {
  @Input({ required: true }) isOpen = false;
  @Output() navigate = new EventEmitter<void>();

  url = environment.homepageBaseUrl + '/';
  fachkraefteOpen = false;

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.fachkraefteOpen && !this.el.nativeElement.contains(event.target)) {
      this.fachkraefteOpen = false;
    }
  }

  toggleFachkraefte(): void {
    this.fachkraefteOpen = !this.fachkraefteOpen;
  }

  closeFachkraefte(): void {
    setTimeout(() => (this.fachkraefteOpen = false), 150);
  }

  handleClick(): void {
    this.fachkraefteOpen = false;
    this.navigate.emit();
  }
}
